import Api from '@/shared/services/Api'

export default 
{

	create(data) {
		return Api().post('notification-create', data)
	},

	get(user_id) {
		return Api().get('notification-get?user_id='+user_id)
	},

	getAll(user_id) {
		return Api().get('notification-get-all?user_id='+user_id)
	},

	seeNotifications(user_id) {
		return Api().get('notification-see?user_id='+user_id)
	}

}